import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "channel-list" }
const _hoisted_2 = { class: "channel-list__row" }
const _hoisted_3 = { class: "news-card__image-wrapper" }
const _hoisted_4 = { class: "news-card__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_widget_block = _resolveComponent("widget-block")!

  return (_ctx.siteList?.items.length)
    ? (_openBlock(), _createBlock(_component_widget_block, {
        key: 0,
        title: _ctx.title,
        "show-divider": !!_ctx.title,
        "btn-label": _ctx.btnLabel,
        "btn-url": _ctx.btnUrl
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteList.items, (siteData) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: siteData.id,
                  class: "channel-list__col channel-list__col--4"
                }, [
                  _createVNode(_component_nav_link, {
                    class: "news-card",
                    to: siteData.url
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_Image, {
                          "image-url": siteData?.parameters?.design.channelImageUrls.channelImageUrl,
                          alt: siteData.name,
                          class: "news-card__image"
                        }, null, 8, ["image-url", "alt"])
                      ]),
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(siteData.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "show-divider", "btn-label", "btn-url"]))
    : _createCommentVNode("", true)
}